export default __webpack_public_path__ + "static/media/MeiDianwafu.c8418bb6.jpg";